import {createApp} from "vue";
import City from './views/City.vue';

import {createRouter, createWebHistory} from "vue-router";
import {createMetaManager} from 'vue-meta';
import App from "./App.vue";
import Privacy from "./views/Privacy";
import Account from "./views/account/Account";
import {createStore} from 'vuex'
import axios from "axios";
import Profile from "./views/account/Profile";
import AddNewWorkplace from "./views/account/workplaces/AddNewWorkplace";
import WorkplacesIndex from "./views/account/workplaces/WorkplacesIndex";
import Index from "./views/Index";
import Login from "./views/auth/Login";
import Workplace from "./views/Workplace.vue";
import VueGtag from "vue-gtag";

const AddNewCity = () => import('./views/City/AddNewCity.vue');

const routes = [
    {
        path: '/',
        component: Index
    },
    {
        path: '/cities/add-new',
        component: AddNewCity,
        name: 'countries.cities.search'
    },
    {
        path: '/cafes/:countrySlug/:citySlug',
        component: City,
        props: true,
        name: 'countries.cities.show'
    },
    {
        path: '/cafes/:countrySlug/:citySlug/:workplaceSlug',
        component: Workplace,
        props: true,
        name: 'countries.cities.workplaces.show'
    },
    {
        path: '/privacy',
        component: Privacy
    },
    {
        path: '/account',
        component: Account,
        children: [
            {
                path: '',
                component: Profile
            },
            {
                path: 'cafes',
                component: WorkplacesIndex
            },
            {
                path: 'cafes/add/:countrySlug/:citySlug',
                component: AddNewWorkplace,
                props: true
            }
        ]
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    routes, // short for `routes: routes`
})


// Create a new store instance.
const store = createStore({
    state() {
        return {
            user: undefined,
            loadingUser: false,
            loadingUserError: null,
            updatingUser: false,
            updatingUserError: null,
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setLoadingUser(state, loading) {
            state.loadingUser = loading;
        },
        setLoadingUserError(state, error) {
            state.loadingUserError = error;
        },
        setUpdatingUser(state, updating) {
            state.updatingUser = updating;
        },
        setUpdatingUserError(state, error) {
            state.updatingUserError = error;
        }
    },
    actions: {
        updateUser({commit, dispatch}, data) {
            commit('setUpdatingUser', true);

            axios.put('/api/user', data).then(() => {
                dispatch('getAuthStatus');
                commit('setUpdatingUserError', null);
            }).catch(error => {
                commit('setUpdatingUserError', error);
            }).finally(() => {
                commit('setUpdatingUser', false);
            });
        },
        getAuthStatus({commit}) {
            commit('setLoadingUser', true);

            axios.get('/api/user').then(response => {
                commit('setUser', response.data);
                commit('setLoadingUserError', null);
            }).catch(error => {
                if (error.response?.status === 401) {
                    commit('setUser', null);
                } else {
                    commit('setLoadingUserError', error);
                }
            }).finally(() => {
                commit('setLoadingUser', false);
            })
        }
    }
})


const app = createApp(App)

app.use(router)
    .use(store)
    .use(createMetaManager()) // add this line
    .use(VueGtag, {
        config: {id: "G-HP9X8DX8Y9"}
    }, router);

app.mount('#app')
